import * as yup from 'yup';

// Copied from CompanyDetailsDE.schema.ts — keep in sync if the desktop rule changes.
const monthRegex = /^(?:0?[1-9]|1[012])$/;

export const foundingDateSchema = yup.object().shape({
  startDateMonth: yup
    .string()
    .required('benötigt')
    .matches(monthRegex, 'ungültige Eingabe'),
  startDateYear: yup
    .string()
    .required('benötigt')
    .min(4, 'benötigt')
    .max(4, 'ungültige Eingabe'),
});
